import bookingPeriodsTable from "./directive";
import BookingPeriodRowModule from "./booking-period-row/module";

const modul = angular
    .module("BookingPeriodTableModule", [BookingPeriodRowModule])

    .directive("bookingPeriodsTable", bookingPeriodsTable);
export default modul.name;
